export const TALENT_ADDRESS_LIMIT = 100;
export const PAYMENT_EMAIL_LIMIT = 100;

export function splitTalentAddress(value: string | null | undefined) {
  const address = String(value || '').trim();
  const match = address.match(/^(.*?)\s+#([^#]+)$/);
  return match ? { street: match[1].trim(), unit: match[2].trim() } : { street: address, unit: '' };
}

/** Compose the existing canonical address column; never truncate a unit or street. */
export function composeTalentAddress(streetValue: string | null | undefined, unitValue: string | null | undefined) {
  const street = splitTalentAddress(streetValue).street;
  const unit = String(unitValue || '').trim().replace(/^#\s*/, '');
  if (!street || /[\x00-\x1f\x7f]/.test(street + unit) || unit.includes('#')) {
    throw new Error('Enter a valid street address and optional unit.');
  }
  const address = unit ? `${street} #${unit}` : street;
  if (Array.from(address).length > TALENT_ADDRESS_LIMIT) {
    throw new Error(`Street address and unit must be ${TALENT_ADDRESS_LIMIT} characters or fewer.`);
  }
  return address;
}

export const paymentEmailLabel = (country: unknown) => Number(country) === 1 ? 'PayPal email' : 'E-transfer email';
export function validPaymentEmail(value: string) {
  const email = value.trim();
  return email.length <= PAYMENT_EMAIL_LIMIT && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && !/[\x00-\x1f\x7f]/.test(email);
}
